/* eslint-disable import/named, vue/multi-word-component-names */
import { Fragment } from 'vue-frag';
import Vue from 'vue';
export default (function () {
    Vue.component('Fragment', Fragment);
});
